import * as Yup from 'yup';
import { Agenda, AgendaType } from '../../models';

export function useValidationSchema() {
  return Yup.object<Agenda>().shape({
    name: Yup.string().nullable().required('Povinné pole'),
    type: Yup.mixed<AgendaType>().nullable().required('Povinné pole'),
  });
}
